import { NgModule } from '@angular/core';
import { translationChunksConfig, translationsEn } from '@spartacus/assets';
import {
  AuthConfig,
  FeaturesConfig,
  I18nConfig,
  OccConfig,
  provideConfig,
  provideConfigFactory,
  RoutingConfig,
  SiteContextConfig,
} from '@spartacus/core';
import {
  BREAKPOINT,
  defaultCmsContentProviders,
  defaultLayoutConfig,
  LayoutConfig,
  layoutConfigFactory,
  mediaConfig,
} from '@spartacus/storefront';
import { environment } from '../../environments/environment';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideConfigFactory(layoutConfigFactory),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig(<OccConfig>{
      backend: {
        occ: {
          baseUrl: environment.baseUrl,
          prefix: environment.prefix,
        },
      },
    }),
    provideConfig(<SiteContextConfig>{
      context: {
        baseSite: ['chimeagent'],
        language: ['en'],
        currency: ['USD'],
        urlParameters: []
        //urlParameters: ['baseSite', 'language', 'currency']
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: translationsEn },
        chunks: translationChunksConfig,
        fallbackLang: 'en',
      },
    }),
    provideConfig(<AuthConfig>{
      authentication: {
        customLoginPage: undefined,
      }
    }),
    provideConfig(
      <LayoutConfig>{
        ...defaultLayoutConfig,
        breakpoints: {
          [BREAKPOINT.xs]: {
            max: 559,
          },
          [BREAKPOINT.sm]: {
            min: 560,
            max: 959,
          },
          [BREAKPOINT.md]: {
            min: 960,
            max: 999,
          },
          [BREAKPOINT.lg]: {
            min: 1000,
            max: 1679,
          },
          [BREAKPOINT.xl]: {
            min: 1680,
          },
        },
        layoutSlots: {
          LoginPageTemplate: {
            header: {
              slots: ['TopContent'],
            },
            navigation: {
              slots: [],
            },
            slots: ['CenterContent'],
            footer: {
              slots: [],
            },
          },
          LandingPage2Template: {
            header: {
              slots: ['TopContent'],
            },
            slots: ['CenterContent'],
            footer: {
              slots: ['Footer'],
            },
            navigation: {
              slots: [],
            },
          },
        },
      },
      false
    ),
    provideConfig(<RoutingConfig>{
      routing: {
        protected: true,
        routes: {
          home: {
            paths: ['homepage']
          },
          purchaseOrders: {
            paths: ['purchase-orders']
          },
          reviewOrders: {
            paths: ['review-order/:cartId']
          },
          ssoLogin: {
            paths: ['sso/login'],
          },
        },
      },
    }),
    provideConfig(<FeaturesConfig>{
      features: {
        level: '221121.11',
      },
    }),
  ],
})
export class SpartacusConfigurationModule {}
